import formatXml from "xml-formatter";
export function getXMLValidity(_ref) {
  var input = _ref.input,
    selectedSpaces = _ref.selectedSpaces,
    encodingRadio = _ref.encodingRadio;
  try {
    formatXml(input, {
      indentation: "  ",
      collapseContent: true,
      lineSeparator: "\n"
    });
    return "XML is valid!";
  } catch (e) {
    throw e;
  }
}